var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "table-calendar-view" },
    [
      !_vm.hasDateFields
        ? _c(
            "div",
            { staticClass: "calendar-empty-state" },
            [
              _c("a-empty", {
                scopedSlots: _vm._u(
                  [
                    {
                      key: "description",
                      fn: function () {
                        return [
                          _c(
                            "div",
                            { staticClass: "empty-state-content" },
                            [
                              _c("h3", [
                                _vm._v(_vm._s(_vm.$t("tables.notAvailable"))),
                              ]),
                              _vm._v(" "),
                              _c("p", [
                                _vm._v(_vm._s(_vm.$t("tables.needDateField"))),
                              ]),
                              _vm._v(" "),
                              _c(
                                "a-button",
                                {
                                  attrs: { type: "primary" },
                                  on: { click: _vm.switchToTableView },
                                },
                                [_vm._v(_vm._s(_vm.$t("tables.switchToTable")))]
                              ),
                            ],
                            1
                          ),
                        ]
                      },
                      proxy: true,
                    },
                  ],
                  null,
                  false,
                  4276635966
                ),
              }),
            ],
            1
          )
        : [
            _c(
              "div",
              { staticClass: "calendar-header" },
              [
                _c("div", { staticClass: "color-legend-wrapper" }, [
                  _c(
                    "div",
                    { staticClass: "color-legend" },
                    _vm._l(_vm.colorLegend, function (item) {
                      return _c(
                        "div",
                        { key: item.value, staticClass: "legend-item" },
                        [
                          _c("div", {
                            staticClass: "color-box",
                            style: { backgroundColor: item.color },
                          }),
                          _vm._v(" "),
                          _c("span", [_vm._v(_vm._s(item.value))]),
                        ]
                      )
                    }),
                    0
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "SupsisButton",
                  {
                    attrs: { type: "primary", ghost: "" },
                    on: { click: _vm.openCalendarSettings },
                  },
                  [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("settings"),
                    ]),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(_vm._s(_vm.$t("tables.calendarSettings"))),
                    ]),
                  ]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _vm.overlayVisible
              ? _c("CalendarSettingsOverlay", {
                  attrs: {
                    fields: _vm.table.fields,
                    calendarSettings: _vm.calendarSettings,
                  },
                  on: {
                    close: function ($event) {
                      _vm.overlayVisible = false
                    },
                    saveSettings: _vm.saveCalendarSettings,
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            _c("FullCalendar", {
              ref: "fullCalendar",
              attrs: { options: _vm.calendarOptions },
            }),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }